<template lang='pug'>
div(class='event')
  div(class='event-time')
    | {{ event.start.format('HH:mm') }} - {{ event.end.format('HH:mm') }}
  div(class='event-title')
    | {{ event.title }} {{ event.busy }}/{{ event.allow }}
  template(v-if='0 === event.busy')
    v-icon(@click.stop='remove' class='event-remove' small) delete_outlined
</template>

<script>
export default {
  props: ['emitter', 'event'],
  methods: {
    remove() {
      this.emitter.$emit('schedule.event.remove', this.event.id)
    }
  }
}
</script>

<style scoped>
.event {}
.event-time {
  font-size: 12px;
}
.event-title {
  font-weight: 500;
}
.event-remove {
  top: 3px;
  right: -10px;
  z-index: 5;
  position: absolute;
  color: #000;
}
</style>
